/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable jsx-a11y/media-has-caption */

'use client'

import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import React, { useState, useRef } from 'react'
import useIdentifyEvent from '@hooks/useIdentityEvent'
import { careersSegmentEventCommonPropFunc } from '@utils/carrersSegmentProperties'
import styles from './styles/video.module.css'

const Video = ({ CMSData }) => {
  const { video, thumbnailForVideo } = CMSData
  useIdentifyEvent()

  const posterUrl = thumbnailForVideo.data.attributes.url

  const [isPlaying, setIsPlaying] = useState(false)
  const videoRef = useRef(null)

  const handleVideoToggle = () => {
    const videoElement = videoRef.current
    if (videoElement.paused) {
      videoElement.play()
      setIsPlaying(true)
    } else {
      videoElement.pause()
      setIsPlaying(false)
    }
  }

  const handleVideoClick = () => {
    handleVideoToggle()
  }

  return (
    <div className={styles.videoDiv}>
      <div className={styles.videoVimeo}>
        <video
          loading="lazy"
          ref={videoRef}
          className={styles.videoVimeo}
          src={video}
          poster={posterUrl}
          onClick={handleVideoClick}
          controls={isPlaying}
        />
        {!isPlaying && (
          <div className={styles.overlay}>
            <p className={styles.overlayText}>Wake up. Refresh. Innovate!</p>
            <p className={styles.overlayText}>#AckerLife</p>
            <span className={styles.overlayText2}>Lakshmi Iyer - Asst. Manager, Actuary</span>
            <button
              type="button"
              aria-label="Play Video"
              className={styles.playButton}
              onClick={() => {
                handleVideoClick()
                ;(async () => {
                  const properties = await careersSegmentEventCommonPropFunc()
                  trackEvent('tap_video_played', {
                    ...properties,
                    url: video,
                  })
                })()
              }}>
              <svg width="50" height="51" viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M24.5812 49.4851C37.9526 49.4851 48.7923 38.6455 48.7923 25.2741C48.7923 11.9027 37.9526 1.06299 24.5812 1.06299C11.2098 1.06299 0.370117 11.9027 0.370117 25.2741C0.370117 38.6455 11.2098 49.4851 24.5812 49.4851Z"
                  fill="white"
                />
                <path
                  d="M22.6521 19.2293C21.361 18.475 19.7383 19.4063 19.7383 20.9017V29.9569C19.7383 31.4501 21.3566 32.3817 22.6478 31.6318L30.4209 27.1176C31.7046 26.3721 31.707 24.519 30.4252 23.7703L22.6521 19.2293Z"
                  fill="black"
                />
              </svg>
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default Video
